import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import apiCall from "../utils/api";
import Loader from "../components/Loader";
import DataTable, { createTheme } from "react-data-table-component";
import "react-tabs/style/react-tabs.css"; // Import react-tabs styles
import "./Dashboard.css"; // Custom styles

ReactModal.setAppElement("#root"); // Important for accessibility

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        localStorage.removeItem("userData");
        const response = await apiCall({
          url: "https://supplier.innovatemr.net/api/v2/supply/getAllocatedSurveys",
          method: "GET",
        });
        let finalAry = response?.result
          ?.filter(
            (f) =>
              parseFloat(f.CPI) >= 10 &&
              f.LOI <= 20 &&
              f.jobCategory !== "Ailment"
          )
          ?.map((item, index) => ({
            ...item,
            index, // or use `serialNumber: index + 1` if you prefer 1-based indexing
          }));

        setData(finalAry);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredData = data.filter(
    (item) =>
      item?.duplicateSurveyIds.filter((f) =>
        f.toString().toLowerCase().includes(searchText.toLowerCase())
      ).length > 0
  );
  const formatDecimal = (value) => parseFloat(value).toFixed(2); // Format to 2 decimal

  const getRate = (rate) => {
    let inputValue = Math.round(rate);

    if (inputValue >= 0 && inputValue < 1) {
      return 20;
    } else if (inputValue >= 0 && inputValue < 2) {
      return 35;
    } else if (inputValue >= 2 && inputValue < 5) {
      return 60;
    } else if (inputValue >= 5 && inputValue < 7) {
      return 70;
    } else if (inputValue >= 7 && inputValue < 9) {
      return 80;
    } else if (inputValue >= 9 && inputValue < 11) {
      return 90;
    } else if (inputValue >= 11 && inputValue < 21) {
      return 100;
    } else if (inputValue >= 21 && inputValue < 24) {
      return 110;
    } else if (inputValue >= 25 && inputValue < 32) {
      return 120;
    } else if (inputValue >= 32) {
      return 140;
    } else {
      return "error with rate";
    }
  };

  const handleRedirect = (row) => {
    localStorage.setItem("userData", JSON.stringify(row));
    window.open("/details", "_blank", "noopener,noreferrer");
  };

  const formatDate = (dateString) => new Date(dateString);
  const columns = [
    { name: "Survey ID", selector: (row) => row.surveyId },
    { name: "Name", selector: (row) => row.surveyName },
    { name: "Country", selector: (row) => row.Country, sortable: true },
    { name: "IR", selector: (row) => row.IR + "%" },
    {
      name: "LOI",
      selector: (row) => parseInt(row.LOI) + " Min",
      sortable: true,
      sortFunction: (rowA, rowB) => parseInt(rowA.LOI) - parseInt(rowB.LOI),
    },
    {
      name: "Remaining",
      selector: (row) => row?.N + " - " + row.remainingN,
      sortable: true,
    },
    { name: "Completes", selector: (row) => row.supCmps, sortable: true },
    { name: "Priority", selector: (row) => row.CPI + "%", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <span
          onClick={() => handleRedirect(row)}
          style={{ cursor: "pointer", color: "#007bff" }}
          title="Open in Modal"
        >
          🔗
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    { name: "Rate", selector: (row) => "₹" + getRate(row.CPI), sortable: true },
    {
      name: "Timing",
      selector: (row) => (row?.OffHourTraffic ? "Yes" : "No"),
    },
    {
      name: "Current Date",
      selector: (row) => formatDate(row.createdDate),
      sortable: true,
      cell: (row) => {
        const formattedDate = new Date(row.createdDate).toLocaleString(
          "en-US",
          {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          }
        );
        return <span>{formattedDate}</span>;
      },
    },
  ];

  if (loading) {
    return <Loader />;
  }

  const tableCustomStyles = {
    headCells: {
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "white",
        fontColor: "white",
        backgroundColor: "#8F27FF",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row?.index % 2 !== 0, // Every even row
      style: {
        backgroundColor: "#F3EBFF",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#8F27FF",
          color: "white",
        },
      },
    },
    {
      when: (row) => row?.index % 2 === 0, // Every even row
      style: {
        backgroundColor: "white",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#8F27FF",
          color: "white",
        },
      },
    },
  ];

  return (
    <div>
      {/* Search input field */}
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Survey ID"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="search-input"
        />
      </div>

      <DataTable
        columns={columns}
        data={filteredData}
        paginationPerPage={25}
        pagination
        highlightOnHover
        striped
        responsive
        pointerOnHover
        fixedHeader
        theme="solarized"
        customStyles={tableCustomStyles}
        conditionalRowStyles={conditionalRowStyles}
        
      />
    </div>
  );
};

export default Dashboard;
